import store from '@/store/index.js'
import i18n from '@/i18n'
import { storageKey } from '@/helpers/localStorage'
function isString(url) {
    if (url != undefined && url != null) {
        return typeof url === 'string' || url instanceof String
    } else {
        return false
    }
}
function numberTotwoCharacterString(value) {
    if (value < 10) {
        return `0${value}`
    } else {
        return value.toString()
    }
}
export function clearMail(mail) {
    return mail.replace(/\s+/g, '').toLowerCase()
}
export function validateMail(mail) {
    let re = /\S+@\S+\.\S+/
    return re.test(String(mail).toLowerCase())
}
export function handleMigratedAssetsToJPEG(url) {
    if (isString(url)) {
        let migratedURL = url
            .replace('jpg', 'jpeg')
            .replace('png', 'jpeg')
            .replace(
                'https://theboringdomain.com/',
                'https://assets.theboringdomain.com/'
            )
        return `${migratedURL}`
    } else {
        return url
    }
}
export function randomPassword(length) {
    var password = ''
    var possible = 'ABCDEFGHKLMNPQRSTUVWXYZ1234567890'

    for (var i = 0; i < length; i++) {
        password += possible.charAt(Math.floor(Math.random() * possible.length))
    }
    return password
}

export function generateUUID() {
    var d = new Date().getTime()
    if (
        typeof performance !== 'undefined' &&
        typeof performance.now === 'function'
    ) {
        d += performance.now()
    }
    var newGuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
        /[xy]/g,
        function(c) {
            var r = (d + Math.random() * 16) % 16 | 0
            d = Math.floor(d / 16)
            return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16)
        }
    )
    return newGuid
}
export function setChartScale(data, isCurrency, floor) {
    let max = 0
    let min = 1000
    data.forEach(key => {
        let value = isCurrency ? Math.round(key.y / 10000) * 100 : key.y
        if (value > max) {
            max = value
        }
        if (value < min) {
            min = value
        }
    })
    const maxOffset = roundNumber(max * 1.2)
    const step = floor ? floorNumber(maxOffset / 3) : roundNumber(maxOffset / 3)
    const newMax = maxOffset == step ? maxOffset : roundNumber(step * 3)
    return {
        max: newMax,
        min: roundNumber(min),
        step: step
    }
}
export function floorNumber(number) {
    return Math.floor(Math.round(number * 100) / 100)
}
export function roundNumber(number) {
    return Math.round(number * 100) / 100
}
export function getPriceValueFromBackend(value) {
    if (value == undefined || value == null) {
        return 0
    }
    let rawNumber = Number(value)
    return parseInt((Math.round(rawNumber * 100) / 10000).toFixed(2))
}

export function getPriceToBackend(value) {
    if (value == undefined || value == null) {
        return 0
    }
    let rawNumber = Number(value)
    let number = Math.floor(Math.round(rawNumber * 10000) / 100)
    return number
}

export function getPriceFromBackend(value) {
    if (value == undefined || value == null) {
        return 0
    }
    let rawNumber = Number(value)
    return (Math.round(rawNumber * 100) / 10000).toFixed(2)
}
export function clearNip(nip) {
    return nip.replace(/-/g, '')
}
export function checkNIP(nip) {
    let nipWithoutDashes = clearNip(nip)
    let reg = /^[0-9]{10}$/
    if (reg.test(nipWithoutDashes) === false) {
        return false
    } else {
        var digits = ('' + nipWithoutDashes).split('')
        var checksum =
            (6 * parseInt(digits[0]) +
                5 * parseInt(digits[1]) +
                7 * parseInt(digits[2]) +
                2 * parseInt(digits[3]) +
                3 * parseInt(digits[4]) +
                4 * parseInt(digits[5]) +
                5 * parseInt(digits[6]) +
                6 * parseInt(digits[7]) +
                7 * parseInt(digits[8])) %
            11
        return parseInt(digits[9]) == checksum
    }
}
export function displayMinutes(value) {
    let seconds = value * 60
    let hours = Math.floor(seconds / 3600)
    let minutes = Math.floor((seconds - hours * 3600) / 60)
    if (value == -1 || value == null) {
        return '-'
    } else if (minutes == 0) {
        return '00'
    } else {
        return numberTotwoCharacterString(minutes)
    }
}
export function displayHour(minutes) {
    let seconds = minutes * 60
    let hours = Math.floor(seconds / 3600)
    if (minutes == -1 || minutes == null) {
        return '-'
    } else if (minutes == 0) {
        return '00'
    } else {
        return numberTotwoCharacterString(hours)
    }
}
export function getElementPath(event) {
    let el = event.target
    let path = []
    while (el) {
        path.push(el)
        if (el.tagName === 'HTML') {
            path.push(document)
            path.push(window)
            return path
        }
        el = el.parentElement
    }
    return path
}
export function getFileExtension(fileName) {
    return fileName.split('.')[fileName.split('.').length - 1].toLowerCase()
}
export function getFileType(fileName) {
    let type = getFileExtension(fileName)
    switch (true) {
        case type == 'png' ||
            type == 'jpg' ||
            type == 'jfif' ||
            type == 'jpeg' ||
            type == 'heic':
            return 'image'
        case type == 'mp4' || type == 'mov':
            return 'movie'
        case type == 'pdf':
            return 'pdf'
        case type == 'xlsx':
            return 'excel'
        case type == 'docx':
            return 'word'
        default: {
            return 'file'
        }
    }
}
export function convertImageUrl(image) {
    const jwt = store.state.user.roles[0].jwt
    return jwt ? `${image}?jwt=${jwt}` : image
}
export function displayTime(minutes) {
    return `${displayHour(minutes)}:${displayMinutes(minutes)}`
}
export function createDateRange(from, to) {
    let currentDay = from
    let range = [from]

    while (currentDay != to) {
        currentDay = this.$moment(currentDay, 'YYYY-MM-DD')
            .add(1, 'days')
            .format('YYYY-MM-DD')
        range.push(currentDay)
    }
    return range
}
export function displayFullDateYYYYMMDD(date) {
    return this.$moment(date, 'YYYY-MM-DD').format('D MMMM YYYY')
}
export function displayDateMMMMYYYY(date) {
    return this.$moment(date, 'YYYY-MM').format('MMMM YYYY')
}
export function checkTeacherPerm(perm) {
    if (!perm || store.state.user.type != 'teacher') {
        return true
    } else {
        return store.state.teacherPerms.includes(perm)
    }
}
export function checkRole(roles) {
    if (!roles) {
        return true
    } else {
        return roles.includes(store.state.user.type)
    }
}
export function checkFeature(feature) {
    if (!feature) {
        return true
    }
    if (feature.includes('!')) {
        return !store.state.school.features[feature.replace('!', '')]
    }
    if (
        !store.state.school.features ||
        store.state.school.features[feature] == null ||
        store.state.school.features[feature] == undefined
    ) {
        return true
    }
    return store.state.school.features[feature]
}
export function initDay(input) {
    if (!input) {
        return {
            start: this.$moment()._d
        }
    } else {
        return {
            start: this.$moment(input, 'YYYY-MM-DD')._d
        }
    }
}
export function setForm(inputs, dataToSend, errors) {
    errors.errors = []
    const keys = Object.keys(inputs)
    if (
        keys.some(key => key == 'password') &&
        keys.some(key => key == 'repeatPassword')
    ) {
        if (inputs.password.value != inputs.repeatPassword.value) {
            errors.set('password')
            errors.set('repeatPassword')
        }
    }
    if (
        keys.some(key => key == 'password') &&
        keys.some(key => key == 'old_password')
    ) {
        if (inputs.password.value != inputs.old_password.value) {
            errors.set('password')
            errors.set('old_password')
        }
    }
    keys.forEach(key => {
        if (
            inputs[key].hidden ||
            (inputs[key].value == -1 && inputs[key].type != 'number-input') ||
            inputs[key].disabled
        ) {
            return
        }
        if (
            inputs[key].required == true &&
            inputs[key].value !== 0 &&
            inputs[key].value !== '0' &&
            !inputs[key].value &&
            inputs[key].type != 'switch'
        ) {
            errors.set(key, i18n.t('FIELD_CANNOT_BE_EMPTY'))
        }
        if (
            (inputs[key].type == 'multi-select' ||
                inputs[key].type == 'kid-select') &&
            inputs[key].required == true &&
            inputs[key].value.length == 0
        ) {
            errors.set(key, i18n.t('FIELD_CANNOT_BE_EMPTY'))
        }
        if (
            inputs[key].type == 'attachments-input' &&
            inputs[key].required &&
            !inputs[key].single &&
            inputs[key].value.length == 0
        ) {
            errors.set(key, i18n.t('FIELD_CANNOT_BE_EMPTY'))
        }
        if (
            inputs[key].type == 'attachments-input' &&
            inputs[key].required &&
            inputs[key].single &&
            !inputs[key].value
        ) {
            errors.set(key, i18n.t('FIELD_CANNOT_BE_EMPTY'))
        }
        if (
            inputs[key].type == 'single-select' &&
            inputs[key].required == true &&
            !inputs[key].value
        ) {
            errors.set(key, i18n.t('FIELD_CANNOT_BE_EMPTY'))
        }
        if (inputs[key].skip) {
            return errors.errors.length == 0
        }
        if (typeof inputs[key].value == 'string') {
            if (inputs[key].type == 'number-input') {
                dataToSend[inputs[key].key] = inputs[key].value
                    ? inputs[key].value
                    : ''
            } else {
                dataToSend[inputs[key].key] = inputs[key].value.trim()
            }
        } else {
            dataToSend[inputs[key].key] = JSON.parse(
                JSON.stringify(inputs[key].value)
            )
        }
    })
    return errors.errors.length == 0
}
export function hideSections(section, keys) {
    keys.forEach(key => {
        section[key].hidden = true
    })
}
export function showSections(section, keys) {
    keys.forEach(key => {
        section[key].hidden = false
    })
}
export function convertHourPixelsToVh(minutes, cellHeight) {
    const proportion = 60 / cellHeight
    return `${minutes / proportion}vh`
}
export function clearForm(inputs) {
    Object.keys(inputs).forEach(key => {
        let type = inputs[key].type
        switch (true) {
            case type == 'diet-select' ||
                type == 'multi-select' ||
                type == 'attachments-input':
                inputs[key].value = []
                break
            case type == 'time-input':
                inputs[key].value = 480
                break
            case type == 'date-select':
                inputs[key].value = this.$moment().format('YYYY-MM-DD')
                break
            default: {
                inputs[key].value = ''
            }
        }
    })
}
export const colors = {
    blue: '#17ACFF',
    darkBlue: '#4A90E2',
    green: '#17DDC0',
    red: '#ff6b81',
    yellow: '#F8CC46',
    apple: '#2ed573',
    label: '#9B9B9B',
    orange: '#ff931e',
    purple: '#826af9',
    salmon: '#ffb8b8',
    navy: '#40739e',
    grey: '#c5c5c7',
    brown: '#795548',
    darkRed: '#c23616',
    darkGreen: '#2E7D32',
    darkOrange: '#F7630C',
    darkYellow: '#EAB543',
    darkSalmon: '#e17055',
    darkPurple: '#4527A0',
    fuchsia: '#ff00ff',
    darkkhaki: '#bdb76b',
    indigo: '#4b0082',
    darkolivegreen: '#556b2f',
    beige: '#f5f5dc',
    lightcyan: '#e0ffff',
    gold: '#ffd700',
    aqua: '#00ffff',
    alert: '#FF2544'
}
export function isRouteActive(router, route) {
    return router.matched.some(item => item.path.includes(route))
}
export function getMinutesFromTimeStamp(timestamp) {
    return (
        this.$moment(timestamp).hours() * 60 + this.$moment(timestamp).minutes()
    )
}
export function getTimeFromTimeStamp(time) {
    return this.$moment(time)
}
export function trimObject(keys, object) {
    keys.forEach(key => delete object[key])
}
export function isAbleToEdit(perm) {
    return checkTeacherPerm(perm) && store.state.user.type != 'parent'
}
export function isMobileDevice() {
    return (
        navigator.userAgent.match(/Android/i) ||
        navigator.userAgent.match(/webOS/i) ||
        navigator.userAgent.match(/iPhone/i) ||
        navigator.userAgent.match(/iPad/i) ||
        navigator.userAgent.match(/iPod/i)
    )
}
export function mobileDeviceType() {
    if (navigator.userAgent.match(/Android/i)) {
        return 'android'
    } else if (
        navigator.userAgent.match(/webOS/i) ||
        navigator.userAgent.match(/iPhone/i) ||
        navigator.userAgent.match(/iPad/i) ||
        navigator.userAgent.match(/iPod/i)
    ) {
        return 'ios'
    }
}
export function setWindowOffset($event, isList, bodyRef) {
    const className = isList ? 'list-content' : 'feature-view-content'
    const largestHeight = window.innerHeight - bodyRef.offsetHeight - 50
    const path = getElementPath($event)
    const index = path.findIndex(item => {
        return item.className == className
    })
    let scrollOffset = 0
    if (path[index]) {
        scrollOffset = path[index].scrollTop
    }
    const listOffset = `calc(${-scrollOffset -
        bodyRef.offsetHeight}px - 2.3rem)`
    const featureViewOffset = `calc(${-bodyRef.offsetHeight +
        scrollOffset}px - 2.3rem)`
    if (largestHeight < $event.clientY) {
        return isList ? listOffset : featureViewOffset
    } else {
        return `-${scrollOffset}px`
    }
}
export function getBackendPrice(value, vue) {
    return `${getPriceFromBackend(value)} ${vue.$t('CURRENCY_PLN')}`
}
export function setLocale(locale) {
    switch (locale) {
        case 'pl':
            return 'pl_PL'
        case 'en':
            return 'en_GB'
        case 'de':
            return 'de_DE'
        default:
            return 'pl_PL'
    }
}
export function getLocale(locale) {
    switch (locale) {
        case 'pl_PL':
            return 'pl'
        case 'en_GB':
            return 'en'
        case 'en_US':
            return 'en'
        case 'de_DE':
            return 'de'
        default:
            return 'pl'
    }
}
export function filterWorkdays(days) {
    return days.filter(date => !store.state.freeDays.some(day => day == date))
}
export function logoutUser(vue) {
    vue.$Network.resetHeaders(vue)
    vue.$store.dispatch('resetStore')
    window.localStorage.removeItem(storageKey())
    vue.$router.push('/')
    window.location.reload()
}
export function getAttachmentName(attachment) {
    const uuidV4Regex = /[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}./i
    const splitArray = attachment.split('/')
    const file = splitArray[splitArray.length - 1].replace(uuidV4Regex, '')
    const extension = getFileExtension(file)
    const filePlaceholder = i18n.t('LABEL_FILE').toLowerCase()
    const name = file == extension ? `${filePlaceholder}.${extension}` : file
    return name
}
export function formatBytes(bytes) {
    if (bytes === 0) return '0 B'

    const k = 1024
    const sizes = ['KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

    const i = Math.floor(Math.log(bytes) / Math.log(k))

    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
}

export const isWinterInspiration = conference => {
    return conference == '5db7cbb6-73e0-4164-9147-726f37de7258'
}
